import { AlertTriangle } from "lucide-react";

// Small floating square "something happened" notification — shown instead of instantly popping
// a full roll dialog when a player walks into a hidden trap/template/sight-cone. Keeps the
// surprise (no auto-roll fired) while still letting the player act on their own time by tapping
// it, rather than being ambushed by a sudden blocking modal mid-exploration.
export default function TriggerBadge({ label, onClick, testId }) {
  return (
    <button
      data-testid={testId}
      onClick={onClick}
      title={label}
      className="fixed bottom-40 md:bottom-24 left-1/2 -translate-x-1/2 z-50 flex flex-col items-center gap-1 group"
    >
      <span className="w-14 h-14 rounded-xl bg-gradient-to-b from-[#3a2414] to-[#20130a] border-2 border-[#D4AF37] shadow-[0_0_18px_rgba(212,175,55,0.55)] flex items-center justify-center animate-pulse group-hover:scale-105 transition-transform duration-200">
        <AlertTriangle className="w-7 h-7 text-[#D4AF37]" />
      </span>
      <span className="text-[10px] uppercase tracking-widest text-[#D4AF37] bg-black/70 rounded-full px-2 py-0.5 max-w-[140px] truncate">
        {label || "Something happened"}
      </span>
    </button>
  );
}
